import { useEffect } from "react";
import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

export default function NotFoundPage() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Page Not Found | Watch Tower";
  }, []);

  return (
    <Result
      status="404"
      title="Page not found"
      subTitle="The page you are looking for does not exist or has been moved."
      extra={
        <Button type="primary" onClick={() => navigate("/watchtower/dashboard")}>
          Go to Dashboard
        </Button>
      }
    />
  );
}
